var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ayuda-tema-base',{attrs:{"busqueda":_vm.busqueda,"color":_vm.color,"faqs":_vm.faqs,"video-url":"https://share.synthesia.io/embeds/videos/0ad913fe-23e9-48ca-aa80-1dd18a17f69c","video-titulo":"Nueva solicitud"}})
}
var staticRenderFns = []

export { render, staticRenderFns }